import { render } from "./BaseCardMenuFloatWrapper.vue?vue&type=template&id=0c651fc0&scoped=true&lang=pug"
const script = {}

import "./BaseCardMenuFloatWrapper.vue?vue&type=style&index=0&id=0c651fc0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c651fc0"]])

export default __exports__